exports = module.exports = require("../../../../build/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".com-post-loading{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;position:fixed;top:0;left:0;width:100%;height:100%;background:#fff;font-size:20px;color:#303133;z-index:999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js!../src/component/post-loading/scss/index.scss
// module id = 504
// module chunks = 0 1 2 3 4